export enum EntryStatus {
  new = -1,
  offer = 0,
  option = 1,
  booking = 2,
  cancellationByClient = 3,
  cancellationByYou = 4,
}
